<div class="permisiuni-actiuni-container">
    <h1 class="permisiuni-actiuni-title">Editare acțiune</h1>
    <form class="permisiuni-actiuni-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="permisiuni-actiuni-field">
            <mat-form-field appearance="fill">
                <mat-label>Nume</mat-label>
                <input type="text" matInput formControlName="name">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>
        <div class="permisiuni-actiuni-field">
            <mat-form-field appearance="fill">
                <mat-label>Slug</mat-label>
                <input type="text" matInput formControlName="slug">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['slug'].valid && form.controls['slug'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>
        <div class="permisiuni-actiuni-field">
            <div class="spinner">
              <mat-spinner color="primary" *ngIf="isPermisiuniLoading"></mat-spinner>
            </div>
            <mat-form-field *ngIf="!isPermisiuniLoading" appearance="fill">
              <mat-label>Permisiuni</mat-label>
              <mat-select formControlName="id_permission">
                <mat-option *ngFor="let permisiune of permisiuni$ | async" [value]="permisiune.id">
                  {{ permisiune.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="!form.controls['id_permission'].valid && form.controls['id_permission'].touched">
                Câmp obligatoriu
              </mat-error>
            </mat-form-field>
        </div>

        <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
        <div class="permisiuni-actiuni-action-btns">
            <button class="buttons" mat-flat-button type="button" (click)="closeDialog()">Close</button>
            <button class="buttons" mat-flat-button type="submit" color="primary" >Save</button>
        </div>
    </form>
</div>
